/*请求订单列表*/
export const GET_ORDER_LIST = 'GET_ORDER_LIST';
/*请求订单详情*/
export const GET_ORDER_DETAIL = 'GET_ORDER_DETAIL';
/*删除订单*/
export const DELETE_ORDER = 'DELETE_ORDER';
